module.exports = __webpack_public_path__ + "img/reading_EN.3d0d41e0.png";